// extracted by mini-css-extract-plugin
export default {"authInputOtp":"Step2OtpVerify_authInputOtp__9aACJ","otpBoxClass":"Step2OtpVerify_otpBoxClass__OcOf7","otpPageParagraph":"Step2OtpVerify_otpPageParagraph__yk8M-"};